// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-54c6ff42] .el-dialog__body {\n  padding: 15px 20px;\n}\n.container .edit-tip[data-v-54c6ff42] {\n  color: #aaaaaa;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
